/**
 * Serviço de Exceções de Janela de Frequência
 *
 * Padrão para todo usuário: 1 dia para trás e 1 dia para frente (aplicado no
 * backend, função registrar_frequencia). Este serviço só lida com as exceções
 * individuais concedidas por ADMIN/ADMINISTRATIVO — uma exceção cobre os dois
 * lados. Ver docs/FREQUENCIA_RETROATIVA_POR_USUARIO.md.
 */

import { apiServiceClient } from "../config/api";

export const frequenciaRetroativaService = {
  /**
   * Janela de lançamento (em dias) do usuário autenticado.
   * @returns {Promise<{dias_limite: number, dias_limite_futuro: number, excecao_ativa: boolean, motivo: string|null, expira_em: string|null}>}
   */
  async getMeuLimite() {
    return apiServiceClient.get("/frequencia/retroativa/meu-limite");
  },

  /**
   * Lista as exceções ativas (ADMIN/ADMINISTRATIVO).
   * @returns {Promise<Array>}
   */
  async listarExcecoes() {
    return apiServiceClient.get("/admin/frequencia/retroativa-excecoes");
  },

  /**
   * Concede (ou substitui) a exceção retroativa de um usuário.
   * @param {Object} params
   * @param {number} params.usuarioId
   * @param {number} [params.diasLimite] - dias liberados para trás; omitir mantém o padrão
   * @param {number} [params.diasLimiteFuturo] - dias liberados para frente; omitir mantém o padrão
   * @param {string} [params.motivo]
   * @param {string} [params.expiraEm] - ISO datetime opcional
   * @returns {Promise<Object>}
   */
  async concederExcecao({ usuarioId, diasLimite, diasLimiteFuturo, motivo, expiraEm }) {
    return apiServiceClient.post("/admin/frequencia/retroativa-excecoes", {
      usuario_id: usuarioId,
      dias_limite: diasLimite ?? null,
      dias_limite_futuro: diasLimiteFuturo ?? null,
      motivo: motivo || null,
      expira_em: expiraEm || null,
    });
  },

  /**
   * Revoga a exceção ativa de um usuário.
   * @param {number} usuarioId
   * @returns {Promise<Object>}
   */
  async revogarExcecao(usuarioId) {
    return apiServiceClient.delete(`/admin/frequencia/retroativa-excecoes/${usuarioId}`);
  },
};

export default frequenciaRetroativaService;
